import { render } from "./CreateJobView.vue?vue&type=template&id=31bb0a04&scoped=true"
import script from "./CreateJobView.vue?vue&type=script&lang=js"
export * from "./CreateJobView.vue?vue&type=script&lang=js"

import "./CreateJobView.vue?vue&type=style&index=0&id=31bb0a04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31bb0a04"]])

export default __exports__